'use strict';

var VideoModal = require('../components/video_modal');

var Hero = function($target) {

	function init() {

		var video_modal;

		$target.find('.cta-btn[data-video-id]').on('click', function(e) {
			e.preventDefault();
			video_modal = new VideoModal($(this).data('video-id'));
		});

	}

	init();
}

module.exports = Hero;